import { ContactsSortProperty } from '@views/contacts/query-api'

import { SortDirection } from '../../../enums/sortDirection'
import { SuppliersTableSortCriterion } from '../elements/SuppliersTable'

const tableSortKeyToApiSortKeyMap: Record<SuppliersTableSortCriterion['key'], ContactsSortProperty> = {
  name: ContactsSortProperty.Name,
}

export const transformSuppliersTableSortToContactsApiSort = (
  tableSortCriteria: SuppliersTableSortCriterion | null,
): { sortDirection: SortDirection; sortProperty: ContactsSortProperty } | undefined => {
  if (!tableSortCriteria) {
    return
  }

  const apiSortKey = tableSortKeyToApiSortKeyMap[tableSortCriteria.key]

  if (!apiSortKey) {
    return
  }

  return {
    sortDirection: tableSortCriteria.direction === 'ascending' ? SortDirection.Asc : SortDirection.Desc,
    sortProperty: apiSortKey,
  }
}
